(function (w, $) {
    var preloader = function () {};

    preloader.init = function () {
        this.$element = $('.preloader-page');
    };

    preloader.show = function () {
        var self = this;
        this.$element.css({
            'display': 'block',
            'opacity': 0,
        });
        this.$element.animate({
            'opacity': 1,
        }, {
            'duration' : 600,
            'complete' : function () {
                self.$element.css({
                    'display': 'block',
                    'opacity': 1,
                });
                $('body').trigger('preloader.show');
            }
        });
    };

    preloader.hide = function () {
        if (this.canHide) {
            var self = this;
            this.$element.animate({
                'opacity': 0,
            }, {
                'duration' : 600,
                'complete' : function () {
                    self.$element.css({
                        'display' : 'none',
                    });
                    $('body').trigger('preloader.hide');
                }
            });
        }
    };

    preloader.canHide = true;

    window.preloader = preloader;

})(window, jQuery);

$(document).ready(function () {
    window.preloader.init();
    setTimeout(function () {
        window.preloader.hide();
    }, 1500);
});